// True when the CLI itself runs from npm's npx cache. We key on the module's own
// `/_npx/` path, not `npm_lifecycle_event`/`npm_command` — those leak to child
// processes, so a global install under a parent `npm exec` would be misdetected.
export function isNpx(selfUrl: string = import.meta.url): boolean {
	return selfUrl.includes("/_npx/");
}
